// bookingPricing.js
export const DEPOSIT_RATE = 0.20;

export function calculateBookingPayment(totalPrice) {
  // Work in cents to avoid floating-point rounding errors.
  const totalCents = Math.round(Number(totalPrice) * 100);

  if (!Number.isFinite(totalCents) || totalCents < 0) {
    throw new Error("The booking total must be a valid, non-negative amount.");
  }

  const depositCents = Math.round(totalCents * DEPOSIT_RATE);

  return {
    total: totalCents / 100,
    deposit: depositCents / 100,
    balance: (totalCents - depositCents) / 100,
  };
}